// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* =============================================
=         Design System Color Palette         =
============================================= */
.styles_color__G6gzm.styles_ocean-50__8iWB\\+ {
  color: #e6f2ff;
}

.styles_color__G6gzm.styles_ocean-100__pQQSf {
  color: #e6f2ff;
}

.styles_color__G6gzm.styles_ocean-200__cNcm- {
  color: #b3daff;
}

.styles_color__G6gzm.styles_ocean-300__1ND\\+S {
  color: #7abfff;
}

.styles_color__G6gzm.styles_ocean-400__AKpJB {
  color: #2392fb;
}

.styles_color__G6gzm.styles_ocean-500__brFfE {
  color: #0074e0;
}

.styles_color__G6gzm.styles_ocean-600__sdKxz {
  color: #043571;
}

.styles_color__G6gzm.styles_space-50__GJyF0 {
  color: #f0f0f0;
}

.styles_color__G6gzm.styles_space-100__t8G6x {
  color: #e3e3e3;
}

.styles_color__G6gzm.styles_space-200__yb6\\+U {
  color: #bfbfbf;
}

.styles_color__G6gzm.styles_space-300__z-u1u {
  color: gray;
}

.styles_color__G6gzm.styles_space-400__msz8X {
  color: #616161;
}

.styles_color__G6gzm.styles_space-500__OEA1k {
  color: #283439;
}

.styles_color__G6gzm.styles_gray-50__kQVAd {
  color: #eff3f6;
}

.styles_color__G6gzm.styles_gray-100__Pha3T {
  color: #e6ecef;
}

.styles_color__G6gzm.styles_gray-200__wYj\\+I {
  color: #cfd8de;
}

.styles_color__G6gzm.styles_gray-300__wqXk8 {
  color: #a8b9c2;
}

.styles_color__G6gzm.styles_gray-400__qzPGp {
  color: #7e98a5;
}

.styles_color__G6gzm.styles_gray-500__AG8JK {
  color: #738f9c;
}

.styles_color__G6gzm.styles_green-50__sJ7l2 {
  color: #e3fdf6;
}

.styles_color__G6gzm.styles_green-100__Ae9T- {
  color: #c5f6ea;
}

.styles_color__G6gzm.styles_green-200__MFiRp {
  color: #69ddc2;
}

.styles_color__G6gzm.styles_green-300__Sg4Y\\+ {
  color: #45bfa3;
}

.styles_color__G6gzm.styles_green-400__V88a8 {
  color: #1cab8a;
}

.styles_color__G6gzm.styles_green-500__vK5eY {
  color: #128268;
}

.styles_color__G6gzm.styles_red-50__JZMUm {
  color: #fff0f3;
}

.styles_color__G6gzm.styles_red-100__DV7z4 {
  color: #f9d2db;
}

.styles_color__G6gzm.styles_red-200__\\+UbLR {
  color: #f8b4c4;
}

.styles_color__G6gzm.styles_red-300__usbgM {
  color: #e85e81;
}

.styles_color__G6gzm.styles_red-400__Qma1S {
  color: #e23661;
}

.styles_color__G6gzm.styles_red-500__sXdPH {
  color: #b82348;
}

.styles_color__G6gzm.styles_yellow-50__DC6VT {
  color: #fffae6;
}

.styles_color__G6gzm.styles_yellow-100__eKKNR {
  color: #fff0b3;
}

.styles_color__G6gzm.styles_yellow-200__-nsCR {
  color: #ffe380;
}

.styles_color__G6gzm.styles_yellow-300__uUc5u {
  color: #ffcf57;
}

.styles_color__G6gzm.styles_yellow-400__Y2qeT {
  color: #ffc60a;
}

.styles_color__G6gzm.styles_yellow-500__RL-1T {
  color: #ffb700;
}

.styles_color__G6gzm.styles_orange-50__4BaNM {
  color: #fff2eb;
}

.styles_color__G6gzm.styles_orange-100__Up9pC {
  color: #ffe4d6;
}

.styles_color__G6gzm.styles_orange-200__AnESL {
  color: #ffc69e;
}

.styles_color__G6gzm.styles_orange-300__PtxQc {
  color: #ffa047;
}

.styles_color__G6gzm.styles_orange-400__\\+J0bT {
  color: #ff7b42;
}

.styles_color__G6gzm.styles_orange-500__-qpeU {
  color: #ee4920;
}

.styles_color__G6gzm.styles_turquoise-50__Cxx3k {
  color: transparent;
}

.styles_color__G6gzm.styles_turquoise-100__24LFI {
  color: #e6fcff;
}

.styles_color__G6gzm.styles_turquoise-200__stH8E {
  color: #b3f5ff;
}

.styles_color__G6gzm.styles_turquoise-300__1L1SN {
  color: #78e2f2;
}

.styles_color__G6gzm.styles_turquoise-400__c-u8p {
  color: #00c7e6;
}

.styles_color__G6gzm.styles_turquoise-500__io83R {
  color: transparent;
}

.styles_color__G6gzm.styles_turquoise-600__ZDq0e {
  color: transparent;
}

.styles_color__G6gzm.styles_violet-50__lRRQn {
  color: #eae6ff;
}

.styles_color__G6gzm.styles_violet-100__LPlES {
  color: #d9d1ff;
}

.styles_color__G6gzm.styles_violet-200__8yfoQ {
  color: #bfb3ff;
}

.styles_color__G6gzm.styles_violet-300__FHR5y {
  color: #9d90ea;
}

.styles_color__G6gzm.styles_violet-400__sEDZF {
  color: #8678d9;
}

.styles_color__G6gzm.styles_violet-500__luJ\\+\\+ {
  color: #6f5ccc;
}

.styles_color__G6gzm.styles_snow-50__crVTX {
  color: white;
}

.styles_color__G6gzm.styles_snow-100__cEdyE {
  color: #f7f7f7;
}

.styles_color__G6gzm.styles_snow-200__bQg2m {
  color: #f0efef;
}

.styles_color__G6gzm.styles_snow-300__MMCz2 {
  color: #e6e6e6;
}

.styles_color__G6gzm.styles_snow-400__v7p4N {
  color: #e1e0e0;
}

.styles_color__G6gzm.styles_snow-500__NLq1r {
  color: #cfcfcf;
}

/* =============================================
=              Background Colors              =
============================================= */
.styles_background-color__kjbtI.styles_ocean__ncLnc {
  background-color: #2392fb;
  color: white;
}

.styles_background-color__kjbtI.styles_ocean-light__8WZY\\+ {
  background-color: #b3daff;
  color: white;
}

.styles_background-color__kjbtI.styles_green__zbuI6 {
  background-color: #1cab8a;
  color: white;
}

.styles_background-color__kjbtI.styles_green-light__hS0KA {
  background-color: #69ddc2;
  color: white;
}

.styles_background-color__kjbtI.styles_red__vnozR {
  background-color: #e23661;
  color: white;
}

.styles_background-color__kjbtI.styles_red-light__3PosE {
  background-color: #f8b4c4;
  color: white;
}

.styles_background-color__kjbtI.styles_orange__hRSc\\+ {
  background-color: #ff7b42;
  color: white;
}

.styles_background-color__kjbtI.styles_orange-light__YfqIH {
  background-color: #ffc69e;
  color: white;
}

.styles_background-color__kjbtI.styles_space__qKFT- {
  background-color: #616161;
  color: white;
}

.styles_background-color__kjbtI.styles_space-light__wLEas {
  background-color: #bfbfbf;
  color: #616161;
}

.styles_background-color__kjbtI.styles_gray-light__ChoqD {
  background-color: #f0efef;
  color: #616161;
}

.styles_background-color__kjbtI.styles_violet__7vCeX {
  background-color: #8678d9;
  color: white;
}

.styles_background-color__kjbtI.styles_violet-light__8lrxY {
  background-color: #bfb3ff;
  color: #616161;
}

.styles_background-color__kjbtI.styles_yellow__bqIBh {
  background-color: #ffc60a;
  color: white;
}

.styles_background-color__kjbtI.styles_yellow-light__GOUG7 {
  background-color: #ffe380;
  color: #616161;
}

/* The "blur" parameter (the third one) for drop shadow is rendered twice as in the box shadow.
 * So we have to divide it by 2 to have the same output as box shadows.
*/
.styles_root__pWvuk {
  background-color: white;
  cursor: pointer;
  padding: 10px 12px ;
}
.styles_root__pWvuk .styles_label__VjVuI {
  font-weight: 400;
  font-size: 1rem;
  letter-spacing: -0.09px;
  line-height: 20px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #283439;
}
.styles_root__pWvuk .styles_action__8HLVb {
  margin-left: 8px ;
}
.styles_root__pWvuk .styles_action__8HLVb.styles_notPersistent__1GPW9 {
  display: none;
}
.styles_root__pWvuk:hover .styles_notPersistent__1GPW9 {
  display: block;
}
.styles_root__pWvuk.styles_button__yICqD:not(:last-of-type) {
  border-bottom: 1px solid #e6ecef;
}
.styles_root__pWvuk.styles_button__yICqD .styles_label__VjVuI {
  color: #0074e0;
}
.styles_root__pWvuk .styles_icon__TeOxO {
  margin-bottom: -2px ;
  margin-top: -2px ;
}
.styles_root__pWvuk .styles_marginRight__bcvRK {
  margin-right: 4px ;
}
.styles_root__pWvuk .styles_badgeWrapper__aC84d {
  margin-left: 8px ;
  width: initial;
}
.styles_root__pWvuk .styles_endLabel__Wr8Yb {
  font-weight: 400;
  font-size: 0.8571428571rem;
  letter-spacing: 0.01px;
  line-height: 18px;
  font-family: "Inter", system-ui, -apple-system, "Segoe UI", "Roboto", "Noto Sans", "Ubuntu", "Cantarell", "Helvetica Neue";
  color: gray;
  margin-left: 8px ;
  margin-right: auto;
  white-space: nowrap;
  width: initial;
}
.styles_root__pWvuk .styles_dragHandle__fK1N1 {
  margin-left: 8px ;
  pointer-events: all;
}
.styles_root__pWvuk .styles_dragHandle__fK1N1 > * {
  cursor: grab;
}
.styles_root__pWvuk .styles_dragHandle__fK1N1 > *:hover {
  background-color: initial;
}
.styles_root__pWvuk:hover {
  background-color: #e6f2ff;
}
.styles_root__pWvuk.styles_highlightedBackground__5RFBZ {
  background-color: #e6f2ff;
}
.styles_root__pWvuk.styles_disabled__yPziZ {
  cursor: default;
}
.styles_root__pWvuk.styles_disabled__yPziZ .styles_label__VjVuI {
  color: #bfbfbf;
}
.styles_root__pWvuk.styles_disabled__yPziZ.styles_button__yICqD .styles_label__VjVuI {
  color: #7abfff;
}
.styles_root__pWvuk.styles_disabled__yPziZ:hover {
  background-color: white;
}`, "",{"version":3,"sources":["webpack://./src/ui-kit/styles/_theme/_colors.scss","webpack://./src/ui-kit/components/option-items/item/styles.module.scss","webpack://./src/ui-kit/styles/_theme/_shadows.scss","webpack://./src/ui-kit/styles/_theme/_typography.scss"],"names":[],"mappings":"AAEA;;+CAAA;AAmFI;EACI,cAjFC;ACAT;;ADgFI;EACI,cAjFC;ACIT;;AD4EI;EACI,cAjFC;ACQT;;ADwEI;EACI,cAjFC;ACYT;;ADoEI;EACI,cAjFC;ACgBT;;ADgEI;EACI,cAjFC;ACoBT;;AD4DI;EACI,cAjFC;ACwBT;;ADwDI;EACI,cAjFC;AC4BT;;ADoDI;EACI,cAjFC;ACgCT;;ADgDI;EACI,cAjFC;ACoCT;;AD4CI;EACI,WAjFC;ACwCT;;ADwCI;EACI,cAjFC;AC4CT;;ADoCI;EACI,cAjFC;ACgDT;;ADgCI;EACI,cAjFC;ACoDT;;AD4BI;EACI,cAjFC;ACwDT;;ADwBI;EACI,cAjFC;AC4DT;;ADoBI;EACI,cAjFC;ACgET;;ADgBI;EACI,cAjFC;ACoET;;ADYI;EACI,cAjFC;ACwET;;ADQI;EACI,cAjFC;AC4ET;;ADII;EACI,cAjFC;ACgFT;;ADAI;EACI,cAjFC;ACoFT;;ADJI;EACI,cAjFC;ACwFT;;ADRI;EACI,cAjFC;AC4FT;;ADZI;EACI,cAjFC;ACgGT;;ADhBI;EACI,cAjFC;ACoGT;;ADpBI;EACI,cAjFC;ACwGT;;ADxBI;EACI,cAjFC;AC4GT;;AD5BI;EACI,cAjFC;ACgHT;;ADhCI;EACI,cAjFC;ACoHT;;ADpCI;EACI,cAjFC;ACwHT;;ADxCI;EACI,cAjFC;AC4HT;;AD5CI;EACI,cAjFC;ACgIT;;ADhDI;EACI,cAjFC;ACoIT;;ADpDI;EACI,cAjFC;ACwIT;;ADxDI;EACI,cAjFC;AC4IT;;AD5DI;EACI,cAjFC;ACgJT;;ADhEI;EACI,cAjFC;ACoJT;;ADpEI;EACI,cAjFC;ACwJT;;ADxEI;EACI,cAjFC;AC4JT;;AD5EI;EACI,cAjFC;ACgKT;;ADhFI;EACI,cAjFC;ACoKT;;ADpFI;EACI,cAjFC;ACwKT;;ADxFI;EACI,kBAjFC;AC4KT;;AD5FI;EACI,cAjFC;ACgLT;;ADhGI;EACI,cAjFC;ACoLT;;ADpGI;EACI,cAjFC;ACwLT;;ADxGI;EACI,cAjFC;AC4LT;;AD5GI;EACI,kBAjFC;ACgMT;;ADhHI;EACI,kBAjFC;ACoMT;;ADpHI;EACI,cAjFC;ACwMT;;ADxHI;EACI,cAjFC;AC4MT;;AD5HI;EACI,cAjFC;ACgNT;;ADhII;EACI,cAjFC;ACoNT;;ADpII;EACI,cAjFC;ACwNT;;ADxII;EACI,cAjFC;AC4NT;;AD5II;EACI,YAjFC;ACgOT;;ADhJI;EACI,cAjFC;ACoOT;;ADpJI;EACI,cAjFC;ACwOT;;ADxJI;EACI,cAjFC;AC4OT;;AD5JI;EACI,cAjFC;ACgPT;;ADhKI;EACI,cAjFC;ACoPT;;AD/JA;;+CAAA;AA8EI;EALA,yBAAA;EACA,YAAA;AC6FJ;;ADzFI;EALA,yBAAA;EACA,YAAA;ACkGJ;;AD9FI;EALA,yBAAA;EACA,YAAA;ACuGJ;;ADnGI;EALA,yBAAA;EACA,YAAA;AC4GJ;;ADxGI;EALA,yBAAA;EACA,YAAA;ACiHJ;;AD7GI;EALA,yBAAA;EACA,YAAA;ACsHJ;;ADlHI;EALA,yBAAA;EACA,YAAA;AC2HJ;;ADvHI;EALA,yBAAA;EACA,YAAA;ACgIJ;;AD5HI;EALA,yBAAA;EACA,YAAA;ACqIJ;;ADjII;EALA,yBAAA;EACA,cAAA;AC0IJ;;ADtII;EALA,yBAAA;EACA,cAAA;AC+IJ;;AD3II;EALA,yBAAA;EACA,YAAA;ACoJJ;;ADhJI;EALA,yBAAA;EACA,cAAA;ACyJJ;;ADrJI;EALA,yBAAA;EACA,YAAA;AC8JJ;;AD1JI;EALA,yBAAA;EACA,cAAA;ACmKJ;;ACtTA;;CAAA;ADdA;EACI,uBAAA;EACA,eAAA;EACA,mBAAA;AA0UJ;AAxUI;EE6CA,gBAAA;EANA,eAAA;EACA,uBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EA4DrB,gBAAA;EACA,uBAAA;EACA,mBAAA;EFxDI,cAAA;AA+UR;AA5UI;EACI,iBAAA;AA8UR;AA5UQ;EACI,aAAA;AA8UZ;AA1UI;EACI,cAAA;AA4UR;AAxUQ;EACI,gCAAA;AA0UZ;AAvUQ;EACI,cAAA;AAyUZ;AArUI;EAEI,oBAAA;EACA,iBAAA;AAsUR;AAnUI;EACI,kBAAA;AAqUR;AAlUI;EACI,iBAAA;EAGA,cAAA;AAkUR;AA/TI;EEDA,gBAAA;EANA,0BAAA;EACA,sBASiB;EARjB,iBAQiB;EAKjB,0HAxDqB;EFmDjB,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;EAGA,cAAA;AAkUR;AA/TI;EACI,iBAAA;EACA,mBAAA;AAiUR;AA/TQ;EACI,YAAA;AAiUZ;AA/TY;EACI,yBAAA;AAiUhB;AA5TI;EACI,yBAAA;AA8TR;AA3TI;EACI,yBAAA;AA6TR;AA1TI;EACI,eAAA;AA4TR;AA1TQ;EACI,cAAA;AA4TZ;AAzTQ;EACI,cAAA;AA2TZ;AAxTQ;EACI,uBAAA;AA0TZ","sourcesContent":["@use 'sass:map';\n\n/* =============================================\n=         Design System Color Palette         =\n============================================= */\n$colors: (\n    // ocean\n    ocean-50: hsla(210, 100%, 95%, 1),\n    ocean-100: hsla(210, 100%, 95%, 1),\n    ocean-200: hsla(209, 100%, 85%, 1),\n    ocean-300: hsla(209, 100%, 74%, 1),\n    ocean-400: hsla(209, 96%, 56%, 1),\n    ocean-500: hsla(209, 100%, 44%, 1),\n    ocean-600: hsla(213, 93%, 23%, 1),\n    // space\n    space-50: hsla(0, 0%, 94%, 1),\n    space-100: hsla(0, 0%, 89%, 1),\n    space-200: hsla(0, 0%, 75%, 1),\n    space-300: hsla(0, 0%, 50%, 1),\n    space-400: hsla(0, 0%, 38%, 1),\n    space-500: hsla(198, 18%, 19%, 1),\n    // gray\n    gray-50: hsla(200, 27%, 95%, 1),\n    gray-100: hsla(200, 21%, 92%, 1),\n    gray-200: hsla(201, 18%, 84%, 1),\n    gray-300: hsla(201, 18%, 71%, 1),\n    gray-400: hsla(200, 18%, 57%, 1),\n    gray-500: hsl(199, 17%, 53%, 1),\n    // green\n    green-50: hsla(164, 85%, 94%, 1),\n    green-100: hsla(165, 74%, 87%, 1),\n    green-200: hsla(166, 63%, 64%, 1),\n    green-300: hsla(166, 49%, 51%, 1),\n    green-400: hsla(166, 72%, 39%, 1),\n    green-500: hsla(166, 76%, 29%, 1),\n    // red\n    red-50: hsla(346, 100%, 97%, 1),\n    red-100: hsla(346, 76%, 90%, 1),\n    red-200: hsla(346, 83%, 84%, 1),\n    red-300: hsla(345, 75%, 64%, 1),\n    red-400: hsla(345, 75%, 55%, 1),\n    red-500: hsla(345, 68%, 43%, 1),\n    // yellow\n    yellow-50: hsla(48, 100%, 95%, 1),\n    yellow-100: hsla(48, 100%, 85%, 1),\n    yellow-200: hsla(47, 100%, 75%, 1),\n    yellow-300: hsla(43, 100%, 67%, 1),\n    yellow-400: hsla(46, 100%, 52%, 1),\n    yellow-500: hsla(43, 100%, 50%, 1),\n    // orange\n    orange-50: hsla(21, 100%, 96%, 1),\n    orange-100: hsla(21, 100%, 92%, 1),\n    orange-200: hsla(25, 100%, 81%, 1),\n    orange-300: hsla(29, 100%, 64%, 1),\n    orange-400: hsla(18, 100%, 63%, 1),\n    orange-500: hsla(12, 86%, 53%, 1),\n    // turquoise\n    turquoise-50: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-100: hsla(187, 100%, 95%, 1),\n    turquoise-200: hsla(188, 100%, 85%, 1),\n    turquoise-300: hsla(188, 82%, 71%, 1),\n    turquoise-400: hsla(188, 100%, 45%, 1),\n    turquoise-500: transparent, // TODO: update this value when it got defined on the designs\n    turquoise-600: transparent, // TODO: update this value when it got defined on the designs\n    // violet\n    violet-50: hsla(250, 100%, 95%, 1),\n    violet-100: hsla(250, 100%, 91%, 1),\n    violet-200: hsla(250, 100%, 85%, 1),\n    violet-300: hsla(249, 68%, 74%, 1),\n    violet-400: hsla(249, 56%, 66%, 1),\n    violet-500: hsla(250, 52%, 58%, 1),\n    // snow\n    snow-50: hsla(0, 0%, 100%, 1),\n    snow-100: hsla(0, 0%, 97%, 1),\n    snow-200: hsla(0, 3%, 94%, 1),\n    snow-300: hsla(0, 0%, 90%, 1),\n    snow-400: hsla(0, 1%, 88%, 1),\n    snow-500: hsla(0, 0%, 81%, 1),\n);\n\n@function color($color) {\n    @return map.get($colors, $color);\n}\n\n@each $name, $color in $colors {\n    .color.#{$name} {\n        color: $color;\n    }\n}\n\n/* =============================================\n=              Background Colors              =\n============================================= */\n$background-colors: (\n    ocean: (\n        color: color(ocean-400),\n        contrast-color: color(snow-50),\n    ),\n    ocean-light: (\n        color: color(ocean-200),\n        contrast-color: color(snow-50),\n    ),\n    'green': (\n        color: color(green-400),\n        contrast-color: color(snow-50),\n    ),\n    green-light: (\n        color: color(green-200),\n        contrast-color: color(snow-50),\n    ),\n    'red': (\n        color: color(red-400),\n        contrast-color: color(snow-50),\n    ),\n    red-light: (\n        color: color(red-200),\n        contrast-color: color(snow-50),\n    ),\n    'orange': (\n        color: color(orange-400),\n        contrast-color: color(snow-50),\n    ),\n    orange-light: (\n        color: color(orange-200),\n        contrast-color: color(snow-50),\n    ),\n    space: (\n        color: color(space-400),\n        contrast-color: color(snow-50),\n    ),\n    space-light: (\n        color: color(space-200),\n        contrast-color: color(space-400),\n    ),\n    gray-light: (\n        color: color(snow-200),\n        contrast-color: color(space-400),\n    ),\n    'violet': (\n        color: color(violet-400),\n        contrast-color: color(snow-50),\n    ),\n    violet-light: (\n        color: color(violet-200),\n        contrast-color: color(space-400),\n    ),\n    'yellow': (\n        color: color(yellow-400),\n        contrast-color: color(snow-50),\n    ),\n    yellow-light: (\n        color: color(yellow-200),\n        contrast-color: color(space-400),\n    ),\n);\n\n@function get-background-color($color-name) {\n    @return map.get($background-colors, $color-name);\n}\n\n@mixin background-color($name) {\n    $colors: get-background-color($name);\n\n    background-color: map.get($colors, color);\n    color: map.get($colors, contrast-color);\n}\n\n@each $name in map-keys($background-colors) {\n    .background-color.#{$name} {\n        @include background-color($name);\n    }\n}\n","@use 'sass:color';\n@use '~$app-web/ui-kit/styles/theme';\n\n.root {\n    background-color: theme.color(snow-50);\n    cursor: pointer;\n    padding: theme.spacing(1.25, 1.5);\n\n    .label {\n        @include theme.typo(body3);\n        @include theme.truncate();\n\n        color: theme.color(space-500);\n    }\n\n    .action {\n        margin-left: theme.spacing(1);\n\n        &.notPersistent {\n            display: none;\n        }\n    }\n\n    &:hover .notPersistent {\n        display: block;\n    }\n\n    &.button {\n        &:not(:last-of-type) {\n            border-bottom: 1px solid theme.color(gray-100);\n        }\n\n        .label {\n            color: theme.color(ocean-500);\n        }\n    }\n\n    .icon {\n        // TODO-MAYBE: get rid of these negative margins whenever the width and height of the Icon component get fixed\n        margin-bottom: theme.spacing(-0.25);\n        margin-top: theme.spacing(-0.25);\n    }\n\n    .marginRight {\n        margin-right: theme.spacing(0.5);\n    }\n\n    .badgeWrapper {\n        margin-left: theme.spacing(1);\n\n        // TODO-MAYBE: Should it handled globally? (probably removing width: 100% from our flex class.)\n        width: initial;\n    }\n\n    .endLabel {\n        @include theme.typo(info3);\n\n        color: theme.color(space-300);\n        margin-left: theme.spacing(1);\n        margin-right: auto;\n        white-space: nowrap;\n\n        // TODO-MAYBE: Should it handled globally? (probably removing width: 100% from our flex class.)\n        width: initial;\n    }\n\n    .dragHandle {\n        margin-left: theme.spacing(1);\n        pointer-events: all;\n\n        & > * {\n            cursor: grab;\n\n            &:hover {\n                background-color: initial;\n            }\n        }\n    }\n\n    &:hover {\n        background-color: theme.color(ocean-50);\n    }\n\n    &.highlightedBackground {\n        background-color: theme.color(ocean-100);\n    }\n\n    &.disabled {\n        cursor: default;\n\n        .label {\n            color: theme.color(space-200);\n        }\n\n        &.button .label {\n            color: theme.color(ocean-300);\n        }\n\n        &:hover {\n            background-color: theme.color(snow-50);\n        }\n    }\n}\n","@use 'sass:map';\n@use 'sass:string';\n\n$shadow-base-color: rgb(9, 30, 66);\n$second-shadow-color: rgba($shadow-base-color, 0.31);\n\n// TODO-MAYBE: Use our design system color palette colors.\n$box-shadows: (\n    sm: (0 1px 1px rgba($shadow-base-color, 0.25), 0 0 1px $second-shadow-color),\n    md: (0 3px 5px rgba($shadow-base-color, 0.2), 0 0 1px $second-shadow-color),\n    lg: (0 8px 12px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    xl: (0 18px 28px rgba($shadow-base-color, 0.15), 0 0 1px $second-shadow-color),\n    // TODO: These are not correct. They should be fixed when the values are fixed in Figma.\n    right: 0 0 20px rgba(73, 73, 73, 0.3),\n    left: 0 0 20px rgba(73, 73, 73, 0.3),\n);\n\n/* The \"blur\" parameter (the third one) for drop shadow is rendered twice as in the box shadow.\n * So we have to divide it by 2 to have the same output as box shadows.\n*/\n$drop-shadows: (\n    sm: (drop-shadow(0 1px 0.5px rgba($shadow-base-color, 0.25)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    md: (drop-shadow(0 3px 2.5px rgba($shadow-base-color, 0.2)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    lg: (drop-shadow(0 8px 6px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n    xl: (drop-shadow(0 18px 14px rgba($shadow-base-color, 0.15)) drop-shadow(0 0 0.5px $second-shadow-color)),\n);\n\n@function box-shadow($shadow: sm) {\n    @return map.get($box-shadows, $shadow);\n}\n\n@function drop-shadow($shadow: sm) {\n    @return map.get($drop-shadows, $shadow);\n}\n","@use 'sass:map';\n@use 'sass:math';\n@use 'misc' as *;\n\n$typography-html-font-size: 14px;\n$typography-font-size: 14px;\n$typography-font-family: 'Inter',\n    system-ui,\n    -apple-system,\n    'Segoe UI',\n    'Roboto',\n    'Noto Sans',\n    'Ubuntu',\n    'Cantarell',\n    'Helvetica Neue';\n\n$typography-font-weights: (\n    regular: 400,\n    medium: 500,\n    bold: 700\n);\n\n$typography-variants: (\n    h1: 24px medium 34px -0.47px,\n    h2: 20px medium 30px -0.33px,\n    h3: 20px regular 30px -0.33px,\n    h4: 16px bold 24px -0.18px,\n    h5: 16px medium 24px -0.18px,\n    body1: 14px bold 20px -0.09px,\n    body2: 14px medium 20px -0.09px,\n    body3: 14px regular 20px -0.09px,\n    info1: 12px bold 18px 0.01px,\n    info2: 12px medium 18px 0.01px,\n    info3: 12px regular 18px 0.01px,\n);\n\n@function font-weight($weight: regular) {\n    @return map.get($typography-font-weights, $weight);\n}\n\n@function px2rem($value) {\n    @return math.div($value, $typography-html-font-size) * math.div($typography-font-size, 14px) * 1rem;\n}\n\n@mixin typo-by-values($font-size, $font-weight, $line-height, $letter-spacing) {\n    @include font-weight($font-weight);\n\n    font-size: px2rem($font-size);\n    letter-spacing: $letter-spacing;\n    line-height: $line-height;\n}\n\n@mixin font-weight($weight: regular, $important: false) {\n    font-weight: font-weight($weight) if-important($important);\n}\n\n@mixin typo($variant) {\n    $variant-values: map.get($typography-variants, $variant);\n\n    @include typo-by-values($variant-values...);\n\n    // TODO: remove this (if it was redundant) after the new typography replaced the old one\n    font-family: $typography-font-family;\n}\n\n@mixin truncate() {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color": `styles_color__G6gzm`,
	"ocean-50": `styles_ocean-50__8iWB+`,
	"ocean-100": `styles_ocean-100__pQQSf`,
	"ocean-200": `styles_ocean-200__cNcm-`,
	"ocean-300": `styles_ocean-300__1ND+S`,
	"ocean-400": `styles_ocean-400__AKpJB`,
	"ocean-500": `styles_ocean-500__brFfE`,
	"ocean-600": `styles_ocean-600__sdKxz`,
	"space-50": `styles_space-50__GJyF0`,
	"space-100": `styles_space-100__t8G6x`,
	"space-200": `styles_space-200__yb6+U`,
	"space-300": `styles_space-300__z-u1u`,
	"space-400": `styles_space-400__msz8X`,
	"space-500": `styles_space-500__OEA1k`,
	"gray-50": `styles_gray-50__kQVAd`,
	"gray-100": `styles_gray-100__Pha3T`,
	"gray-200": `styles_gray-200__wYj+I`,
	"gray-300": `styles_gray-300__wqXk8`,
	"gray-400": `styles_gray-400__qzPGp`,
	"gray-500": `styles_gray-500__AG8JK`,
	"green-50": `styles_green-50__sJ7l2`,
	"green-100": `styles_green-100__Ae9T-`,
	"green-200": `styles_green-200__MFiRp`,
	"green-300": `styles_green-300__Sg4Y+`,
	"green-400": `styles_green-400__V88a8`,
	"green-500": `styles_green-500__vK5eY`,
	"red-50": `styles_red-50__JZMUm`,
	"red-100": `styles_red-100__DV7z4`,
	"red-200": `styles_red-200__+UbLR`,
	"red-300": `styles_red-300__usbgM`,
	"red-400": `styles_red-400__Qma1S`,
	"red-500": `styles_red-500__sXdPH`,
	"yellow-50": `styles_yellow-50__DC6VT`,
	"yellow-100": `styles_yellow-100__eKKNR`,
	"yellow-200": `styles_yellow-200__-nsCR`,
	"yellow-300": `styles_yellow-300__uUc5u`,
	"yellow-400": `styles_yellow-400__Y2qeT`,
	"yellow-500": `styles_yellow-500__RL-1T`,
	"orange-50": `styles_orange-50__4BaNM`,
	"orange-100": `styles_orange-100__Up9pC`,
	"orange-200": `styles_orange-200__AnESL`,
	"orange-300": `styles_orange-300__PtxQc`,
	"orange-400": `styles_orange-400__+J0bT`,
	"orange-500": `styles_orange-500__-qpeU`,
	"turquoise-50": `styles_turquoise-50__Cxx3k`,
	"turquoise-100": `styles_turquoise-100__24LFI`,
	"turquoise-200": `styles_turquoise-200__stH8E`,
	"turquoise-300": `styles_turquoise-300__1L1SN`,
	"turquoise-400": `styles_turquoise-400__c-u8p`,
	"turquoise-500": `styles_turquoise-500__io83R`,
	"turquoise-600": `styles_turquoise-600__ZDq0e`,
	"violet-50": `styles_violet-50__lRRQn`,
	"violet-100": `styles_violet-100__LPlES`,
	"violet-200": `styles_violet-200__8yfoQ`,
	"violet-300": `styles_violet-300__FHR5y`,
	"violet-400": `styles_violet-400__sEDZF`,
	"violet-500": `styles_violet-500__luJ++`,
	"snow-50": `styles_snow-50__crVTX`,
	"snow-100": `styles_snow-100__cEdyE`,
	"snow-200": `styles_snow-200__bQg2m`,
	"snow-300": `styles_snow-300__MMCz2`,
	"snow-400": `styles_snow-400__v7p4N`,
	"snow-500": `styles_snow-500__NLq1r`,
	"background-color": `styles_background-color__kjbtI`,
	"ocean": `styles_ocean__ncLnc`,
	"ocean-light": `styles_ocean-light__8WZY+`,
	"green": `styles_green__zbuI6`,
	"green-light": `styles_green-light__hS0KA`,
	"red": `styles_red__vnozR`,
	"red-light": `styles_red-light__3PosE`,
	"orange": `styles_orange__hRSc+`,
	"orange-light": `styles_orange-light__YfqIH`,
	"space": `styles_space__qKFT-`,
	"space-light": `styles_space-light__wLEas`,
	"gray-light": `styles_gray-light__ChoqD`,
	"violet": `styles_violet__7vCeX`,
	"violet-light": `styles_violet-light__8lrxY`,
	"yellow": `styles_yellow__bqIBh`,
	"yellow-light": `styles_yellow-light__GOUG7`,
	"root": `styles_root__pWvuk`,
	"label": `styles_label__VjVuI`,
	"action": `styles_action__8HLVb`,
	"notPersistent": `styles_notPersistent__1GPW9`,
	"button": `styles_button__yICqD`,
	"icon": `styles_icon__TeOxO`,
	"marginRight": `styles_marginRight__bcvRK`,
	"badgeWrapper": `styles_badgeWrapper__aC84d`,
	"endLabel": `styles_endLabel__Wr8Yb`,
	"dragHandle": `styles_dragHandle__fK1N1`,
	"highlightedBackground": `styles_highlightedBackground__5RFBZ`,
	"disabled": `styles_disabled__yPziZ`
};
export default ___CSS_LOADER_EXPORT___;
